import { twMerge } from 'tailwind-merge';

import { ChevronIcon } from '@/shared/assets';
import { AmountNumberInput } from '@/shared/ui';

import { ICurrency } from '../../types';
import { CurrenciesSelect } from '../currencies-select';
import { CurrencyIcon } from '../currency-icon';
import { IAmountInputProps } from '../types';

export const AmountBlock = <T extends ICurrency>({
  value,
  onValueChange,
  onSelectCurrency,
  currency,
  disabled,
  isInvalid,
  placeholder,
  className,
  inputClassName,
  defaultCurrency,
}: IAmountInputProps<T>) => {
  const selectCurrencyHandler = (currency: ICurrency | null) => {
    onSelectCurrency?.(currency);
  };

  return (
    <div className={twMerge('rounded-[24px] bg-surface-01 p-4', className)}>
      {placeholder && (
        <p className="mb-4 text-base-100 typography-14m">{placeholder}</p>
      )}
      <div className="flex items-center justify-between gap-3">
        <CurrenciesSelect
          value={currency ?? null}
          onSelect={selectCurrencyHandler}
          disabled={disabled}
          searchProps={{
            placeholder: 'Search a currency',
          }}
          triggerProps={{
            CustomTrigger: (
              <div className="flex items-center gap-3">
                {currency?.ticker ? (
                  <CurrencyIcon ticker={currency.ticker} size="lg" />
                ) : (
                  <div className="flex size-10 items-center justify-center rounded-full bg-base-500 bg-surface-02">
                    <CurrencyIcon size="sm" />
                  </div>
                )}
                <div className="flex items-center gap-1">
                  <p className="typography-16r">
                    {currency?.ticker ?? 'Currency'}
                  </p>
                  <ChevronIcon className="h-5 w-5 rotate-90" />
                </div>
              </div>
            ),
          }}
        />

        <AmountNumberInput
          prefix={(currency?.symbol || currency?.ticker) ?? '$'}
          value={value ?? '0'}
          onValueChange={onValueChange}
          disabled={disabled}
          className={inputClassName}
          isInvalid={isInvalid}
          wrapperClassName="w-max"
        />
      </div>
    </div>
  );
};
